import { Spin, Modal } from "antd";
import React, { useState } from "react";
import ClassForm from "./ClassForm";
import { addClass } from "../../../../services/trialClassService";

function ClassAdd(props) {
  const initialValues = {
    classCode: "",
    maxVacancy: 500,
    location: "online",
  };

  const [status, setStatus] = useState({
    type: "IDLE",
    message: "In idle mode",
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values,
    };

    payload.startTime = payload.startDate;
    payload.endTime = payload.endDate;
    setStatus({ type: "LOADING", message: "Request in Progress!" });

    await addClass(payload)
      .then((response) => {
        console.log("Successfully Added! ", response);
        setStatus({ type: "SUCCESS", message: "Data added successfully!" });
      })
      .catch((error) => {
        alert("Posting data to backend failed!");
        if (error?.response?.data?.message)
          setStatus({ type: "ERROR", message: error.response.data.message });
        else setStatus({ type: "ERROR", message: "Something went wrong!" });
      });
  };

  return (
    <Modal
      title={`Add Class`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === "LOADING" ? (
        <Spin size="large" />
      ) : (
        <ClassForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          setStatus={setStatus}
        />
      )}
    </Modal>
  );
}

export default ClassAdd;
